// Listen for 'keydown' events to detect when the Tab key is pressed.
// If Tab is pressed, add a class to the body to enable focus outlines.
document.addEventListener('keydown', (event) => {
    if (event.key === 'Tab') {
        document.body.classList.add('js-tabkey-outline');
    } else if (
        event.key === 'ArrowDown' ||
        event.key === 'ArrowUp' ||
        event.key === 'ArrowRight' ||
        event.key === 'ArrowLeft'
    ) {
        document.body.classList.add('js-arrowkey-outline');
    }
});

// Listen for 'click' events to remove the focus outline class from the body.
// This disables focus outlines when the user interacts with the mouse.
const removeOutlines = () => {
    document.body.classList.remove('js-arrowkey-outline', 'js-tabkey-outline');
}

document.addEventListener('mousedown', removeOutlines);
document.addEventListener('touchstart', removeOutlines, { passive: true });